<section>
    <div class="section-header">
        <h2 class="section-heading h3" i18n="Bank account page title">
            Payment Methods
        </h2>
        <lsq-button
            *ngIf="userCanEditBankAccounts$ | async"
            buttonClass="section-heading-action-btn"
            appearance="secondary"
            (buttonClick)="handleAddBankAccountClick()"
            i18n="Add bank account button"
        >
            Add New Method
        </lsq-button>
    </div>

    <ng-container *ngIf="!(initialized$ | async)">
        <lsq-circle-loader></lsq-circle-loader>
    </ng-container>

    <div *ngIf="!hasNoData$ | async; else data" class="no-data-box">
        <div class="no-data-box-text">
            <h3 class="no-data-box-title" i18n="No bank accounts message">
                You currently have no bank accounts set up.
            </h3>
            <p class="no-data-box-description" i18n="No bank accounts details">
                Once you've set up a bank account, you'll be able to receive payments.
            </p>
        </div>

        <div class="no-data-box-icon">
            <div class="icon-border-top"></div>
            <div class="icon-border-right"></div>
            <div class="icon-border-bottom"></div>
            <div class="icon-border-left"></div>
            <lsq-icon [type]="icons.PiggyBank" [color]="color.GrayLight" [width]="58" [height]="58">
            </lsq-icon>
        </div>
    </div>

    <automatic-funding *ngIf="showAutomaticFundingSection$ | async"> </automatic-funding>

    <ng-template #data>
        <div *ngIf="bankAccountWarningMessage$ | async" class="bank-accounts-warning">
            <lsq-icon [type]="icons.Alert"></lsq-icon>
            <div>
                {{ bankAccountWarningMessage$ | async }}
            </div>
        </div>
        <div class="bank-accounts">
            <bank-account-card
                *ngFor="let bankAccount of bankAccounts$ | async"
                [bankAccount]="bankAccount"
                (setDefaultClick)="handleMakeDefaultBankAccountClick(bankAccount)"
                (removeClick)="handleRemoveBankAccountClick(bankAccount)"
            >
            </bank-account-card>
        </div>
    </ng-template>
</section>

<ng-template
    #removeBankAccountModalBody
    let-accountName="accountName"
    let-bankName="bankName"
    let-redactedAccountNumber="redactedAccountNumber"
>
    <p>
        <span i18n="Name label for removing bank account">Name: </span>
        <strong>{{ accountName }}</strong
        ><br />
        <span i18n="Bank label for removing bank account">Bank: </span>
        <strong>{{ bankName }}</strong
        ><br />
        <span i18n="Account number for removing bank account">Account #: </span>
        <strong>{{ redactedAccountNumber }}</strong
        ><br />
    </p>
    <p [style.margin-top]="'2rem'" i18n="Remove bank account warning">
        This account will be removed from your list of bank accounts, but may be re-added at any
        time.
    </p>
</ng-template>

<ng-template
    #makeDefaultModalBody
    let-accountName="accountName"
    let-bankName="bankName"
    let-redactedAccountNumber="redactedAccountNumber"
    let-isPlatform="isPlatform"
>
    <span *ngIf="isPlatform">
        <p>
            Changing your default payment method will affect where all early payment requests are
            sent.
        </p>
        <br />
    </span>
    <p>
        <span i18n="Name label for make default bank account">Name: </span>
        <strong>{{ accountName }}</strong
        ><br />
        <span i18n="Bank label for make default bank account">Bank: </span>
        <strong>{{ bankName }}</strong
        ><br />
        <span i18n="Account number label for make default bank account">Account #: </span>
        <strong>{{ redactedAccountNumber }}</strong
        ><br />
    </p>
</ng-template>
